// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { filterListStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListFilterList";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

filterListStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 8px 8px 0;
        ${xScreen("lte", "md")} {
            margin: 0 16px;
        }
    `,
};
filterListStyles.filterText = {
    variant: "h5",
    as: "p",
    css: css`
        margin: 0;
    `,
};
filterListStyles.skipFiltersButtonWrapper = {
    css: css`
        position: relative;
        top: -65px;
        width: 100%;
    `,
};
filterListStyles.filterTag = {
    css: css`
        border-radius: 13px;
        padding: 7px 12px 7px 8px;
        margin: 4px 4px 0 0;
        white-space: nowrap;
        & > span {
            line-height: 11px;
            text-wrap: nowrap;
            overflow: visible;
        }
        ${IconWrapper} {
            width: 8px;
        }
    `,
};
